import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { IconVersions } from '@contrast-security-inc/design-system-foundations'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { SessionMetadataModal } from './session-metadata-modal'
import { useSessionMetadataAction } from './use-session-metadata-action'
import { formatStyles } from '../../react-intl-helpers'

export const SessionMetadataAction = ({
  applicationUuid,
  organizationUuid,
  appName,
  filterToggle,
  filtersActive,
  filterFields,
  totalAppCustomAgentSession
}) => {
  const intl = useIntl()
  const {
    sessionText,
    isActive,
    onClear,
    isModalOpen,
    setIsModalOpen,
    onSubmit,
    onCancel,
    activeSession,
    isUsingMostRecentSession,
    isRemovableSession,
    hasCustomSession
  } = useSessionMetadataAction({
    applicationUuid,
    organizationUuid,
    onSessionChange: React.useCallback((it) => it, []), // because ts
    filterToggle,
    filtersActive,
    totalAppCustomAgentSession
  })

  return (
    <>
      {isActive && (
        <div
          className={css`
            cursor: auto;
            display: flex;
            position: absolute;
            justify-content: flex-end;
            width: 300px;
            right: 52px;
            bottom: 35px;
          `}
        >
          <Text font="metadata">
            {intl.formatMessage(
              { id: 'title_sessionMetadataCurrent' },
              {
                ...formatStyles.bold,
                sessionText
              }
            )}
          </Text>
          <Link
            font="metadata"
            className={css`
              margin-left: 8px;
            `}
            onClick={onClear}
          >
            {intl.formatMessage({ id: 'action_clear' })}
          </Link>
        </div>
      )}
      <Tooltip body={intl.formatMessage({ id: 'title_sessionMetadata' })}>
        <span
          data-testid="session-metadata-action-icon"
          className={css`
            padding-left: 8px;
            cursor: pointer;
          `}
          onClick={() => setIsModalOpen(true)}
        >
          <IconVersions color={isActive ? 'teal70' : undefined} />
        </span>
      </Tooltip>
      {isModalOpen && (
        <SessionMetadataModal
          isOpen={isModalOpen}
          onSubmit={onSubmit}
          onCancel={onCancel}
          onClear={onClear}
          activeSession={activeSession}
          appName={appName}
          filterFields={filterFields}
          applicationUuid={applicationUuid}
          organizationUuid={organizationUuid}
          isUsingMostRecentSession={isUsingMostRecentSession}
          isRemovableSession={isRemovableSession}
          hasCustomSession={hasCustomSession}
        />
      )}
    </>
  )
}
